module.exports = __webpack_public_path__ + "img/508.80421695.png";